import { get, post } from "@/axios";

/**
 * 获取当前未完成的装箱单。
 */
export const getPackingAssistantCurrent = function () {
  return get("/wms/packing/assistant/getCurrent");
};

/**
 * 根据 SKU 查询马帮库存和当前装箱占用数量。
 */
export const queryPackingAssistantStock = function (params) {
  return post("/wms/packing/assistant/queryStock", params);
};

/**
 * 提交本次扫码装箱明细。
 */
export const savePackingAssistantDetail = function (params) {
  return post("/wms/packing/assistant/saveDetail", params);
};

/**
 * 修改已有装箱明细数量。
 */
export const updatePackingAssistantDetail = function (params) {
  return post("/wms/packing/assistant/updateDetail", params);
};

/**
 * 删除已有装箱明细。
 */
export const deletePackingAssistantDetail = function (params) {
  return post("/wms/packing/assistant/deleteDetail", params);
};

/**
 * 完成当前装箱单。
 */
export const completePackingAssistant = function (params) {
  return post("/wms/packing/assistant/complete", params);
};

/**
 * 对指定装箱单执行马帮出库。
 */
export const mabangOutPackingAssistant = function (params) {
  return post("/wms/packing/assistant/mabangOut", params);
};

/**
 * 分页查询装箱历史。
 */
export const queryPackingAssistantHistory = function (params) {
  return post("/wms/packing/assistant/queryHistory", params);
};

/**
 * 查询指定装箱单的马帮出库履历。
 */
export const queryPackingAssistantMabangOutLog = function (params) {
  return post("/wms/packing/assistant/queryMabangOutLog", params);
};
